module.exports = __webpack_public_path__ + "img/icon_guanli .713787c5.png";